export default __webpack_public_path__ + "static/media/96.65e9c756.jpg";